const initialState = {
  isLoading: false,
  totalRegistros: 0,
  tipoEquipamento: [],
  label: '',
  id: 0,
  nome: '',
  temperaturaMin: null,
  temperaturaMax: null,
  temperaturaAlertaMin: null,
  temperaturaAlertaMax: null,
  excluido: false
}

export function tipoEquipamento(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_TIPO_EQUIPAMENTO':
      return {
        ...state,
        tipoEquipamento: action.tipoEquipamento,
        totalRegistros: action.totalRegistros
      }
    case 'FETCHED_LABEL_TIPO_EQUIPAMENTO':
      return {
        ...state,
        label: action.label,
      }
    case 'TIPO_EQUIPAMENTO_DETAIL':
      return action.tipoEquipamento
    case 'TIPO_EQUIPAMENTO_UPDATED':
      return state
    case 'TIPO_EQUIPAMENTO_CLEAR':
      return initialState
    case 'TIPO_EQUIPAMENTO_CLEAR_ALL':
      return {
        ...state,
        tipoEquipamento: []
      }
    case 'TIPO_EQUIPAMENTO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'TIPO_EQUIPAMENTO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'TIPO_EQUIPAMENTO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
